import { routes } from '../RouterPath';
import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const filtersBreadcrumbs = (filterName = '') : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Каталог',
        url: '',
    },
    {
        key: '2',
        value: 'Фильтры',
        url: routes.filters,
    },
    {
        key: '3',
        value: filterName,
        url: '',
    },
]);
